import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, CheckCircle, AlertCircle, FileText, BarChart3, Target, Users, Mail, Download } from 'lucide-react';
import MSQQuestionnaire from '../components/MSQQuestionnaire';
import { apiCall } from '../utils/api';
import { getPublicConfirmationPage } from '../utils/confirmationPageApi';
import { PUBLIC_SEND_MAIL } from '../config/api';

const MSQIndex = () => {
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    fname: '',
    lname: '',
    email: '',
    confirmEmail: '',
    accessCode: ''
  });
  const [step1Data, setStep1Data] = useState({
    Position1: '',
    Position2: '',
    Position3: '',
    Position4: '',
    Position5: ''
  });
  const [step2Data, setStep2Data] = useState({
    Capability1: '',
    Capability2: '',
    Capability3: '',
    Capability4: '',
    Capability5: ''
  });
  const [step3Data, setStep3Data] = useState({
    Channel1: '',
    Channel2: '',
    Channel3: '',
    Channel4: '',
    Channel5: ''
  });
  const [step4Data, setStep4Data] = useState({
    Buyer1: '',
    Buyer2: '',
    Buyer3: '',
    Buyer4: '',
    Buyer5: ''
  });
  const [step5Data, setStep5Data] = useState({
    Communication1: '',
    Communication2: '',
    Communication3: '',
    Communication4: '',
    Communication5: ''
  });
  const [step6Data, setStep6Data] = useState({
    Conversations1: '',
    Conversations2: '',
    Conversations3: '',
    Conversations4: '',
    Conversations5: ''
  });
  const [step7Data, setStep7Data] = useState({
    Product1: '',
    Product2: '',
    Product3: '',
    Product4: '',
    Product5: ''
  });
  const [step8Data, setStep8Data] = useState({
    Management1: '',
    Management2: '',
    Management3: '',
    Management4: '',
    Management5: ''
  });
  const [step9Data, setStep9Data] = useState({
    Service1: '',
    Service2: '',
    Service3: '',
    Service4: '',
    Service5: ''
  });
  const [step10Data, setStep10Data] = useState({
    Organisation1: '',
    Organisation2: '',
    Organisation3: '',
    Organisation4: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [accessCodeValid, setAccessCodeValid] = useState(false);
  const [assessmentResults, setAssessmentResults] = useState(null);
  const [confirmationContent, setConfirmationContent] = useState(null);

  // Fetch confirmation page content and send email

  
  useEffect(() => {
    const fetchConfirmationContent = async () => {
      try {
        // Only fetch if we're on step 11 and haven't fetched yet
        if (currentStep === 10 && !confirmationContent) {
          const sessionData = getSessionData();
          console.log('🔍 Session data:', sessionData);
          
          if (sessionData && sessionData.session) {
            // Send email by session
            try {
              console.log('📧 Sending email for session:', sessionData.session);
              const emailResponse = await apiCall(PUBLIC_SEND_MAIL, {
                method: 'POST',
                data: {
                  session: sessionData.session,
                  site_id: sessionData.site_id,
                  type: 'survey'
                }
              });
              
              console.log('📨 Email API response:', emailResponse);
              
              if (emailResponse.success) {
                console.log('✅ Email sent successfully');
              } else {
                console.warn('⚠️ Email sending failed:', emailResponse.error);
              }
            } catch (emailError) {
              console.error('❌ Error sending email:', emailError);
            }
          }
          
          if (sessionData && sessionData.site_id) {
            console.log('🚀 Fetching confirmation content for site_id:', sessionData.site_id);
            const response = await getPublicConfirmationPage(sessionData.site_id);
            
            console.log('📡 Full API response:', response);
            
            if (response.success && response.data) {
              console.log('✅ Confirmation content fetched successfully:', response.data);
              setConfirmationContent(response.data);
            } else {
              console.warn('⚠️ No confirmation content found in response');
              // Set empty object to prevent refetching
              setConfirmationContent({});
            }
          } else {
            console.warn('❌ No site_id found in session data');
            setConfirmationContent({});
          }
        }
      } catch (error) {
        console.error('❌ Error fetching confirmation content:', error);
        setConfirmationContent({});
      }
    };

    fetchConfirmationContent();
  }, [currentStep, confirmationContent]);

  // Prevent browser back button on step 11 (final confirmation page - no back navigation allowed)
  useEffect(() => {
    if (currentStep === 11) {
      // Push current state to prevent back navigation
      window.history.pushState(null, '', window.location.href);
      
      const handlePopState = () => {
        window.history.pushState(null, '', window.location.href);
      };
      
      window.addEventListener('popstate', handlePopState);
      
      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [currentStep]);

  // API function to send survey step data
  const sendSurveyStepData = async (stepNumber, stepData) => {
    try {
     
      // Get session data from localStorage
      const sessionData = getSessionData();
      
      let stepTotal = 0;
      let newKey = '';
      for (const key in stepData) {
        stepTotal = stepTotal + parseInt(stepData[key]);
        newKey = key.replace(/[0-9]/g, '');
      }



      stepTotal = stepTotal * 10;
      stepData[newKey + 'Percent'] = stepTotal;

      if(stepNumber === 9) {
        stepData.status = "processed";
      }

      if(stepNumber === 9) {
        sessionData.onTrack = 0;
        sessionData.offTrack = 0;
        sessionData.zero = 0;
        sessionData.total_score = 0;
        // For loop to iterate through sessionData.step1 and sessionData.step2
        const steps = ['step1', 'step2', 'step3', 'step4', 'step5', 'step6', 'step7', 'step8', 'step9'];
        for (const stepKey of steps) {

          if (sessionData[stepKey]) {
            console.log(`Processing ${stepKey}:`, sessionData[stepKey]);
            // You can add processing logic here for each step
            for (const key in sessionData[stepKey]) {
              console.log('CHECK KEY', sessionData[stepKey][key]);
              if(sessionData[stepKey][key] === '2') {
                sessionData.onTrack = sessionData.onTrack + 1;
              } else if(sessionData[stepKey][key] === '1') {
                sessionData.offTrack = sessionData.offTrack + 1;
              } {
                //sessionData.zero = sessionData.zero + 1;
              }

            }
          }
        }

        stepData.on_track = Math.round((sessionData.onTrack * 2) / 90 * 100);
        stepData.off_track = Math.round(100 - stepData.on_track);
        stepData.total_score = Math.round(( ( (sessionData.onTrack * 2) + (sessionData.offTrack * 1) + (0) ) / 90 ) * 100);
      }
      

      
    console.log('🔍 step2StorageData:', sessionData);

      const endpoint = `/public/surveys/session/${sessionData.session || 'default'}`;
      const payload = {
        step: stepNumber,
        data: stepData
      };
      
      console.log(`📤 API Call Details:`, {
        endpoint,
        sessionData,
        stepNumber,
        payload
      });
      
      const result = await apiCall(endpoint, {
        method: 'PUT',
        data: payload
      });
      
      if (result.success) {

        //Send email to user
        

        console.log(`✅ Step ${stepNumber} data sent successfully:`, result.data);
        return true;
      } else {
        console.error(`❌ Failed to send step ${stepNumber} data:`, result.error);
        return false;
      }
    } catch (error) {
      console.error(`💥 Error sending step ${stepNumber} data:`, error);
      return false;
    }
  };


  // Get session data from survey_form_data
  const getSessionData = () => {
    // Get existing survey data from localStorage
    const existingData = localStorage.getItem('survey_form_data');
    let surveyData = existingData ? JSON.parse(existingData) : {};
    
    console.log('📂 Retrieved session data from survey_form_data:', surveyData);
    return surveyData;
  };

  // Check for URL parameters on component mount
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const step = urlParams.get('step');
    const firstName = urlParams.get('firstName');
    const lastName = urlParams.get('lastName');
    const email = urlParams.get('email');

    if (step === '2' && firstName && lastName && email) {
      // Skip to step 2 if form data is provided
      setFormData({
        fname: decodeURIComponent(firstName),
        lname: decodeURIComponent(lastName),
        email: decodeURIComponent(email),
        confirmEmail: decodeURIComponent(email),
        accessCode: 'Q6674MS' // Default access code
      });
      // Get session data for URL parameter users
      getSessionData();
      setCurrentStep(2);
    }
  }, [location.search]);

  // Valid access codes (you can expand this list)
  const validAccessCodes = ['Slater', 'Q6674MS', 'Test123'];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }

    // Validate access code in real-time
    if (field === 'accessCode') {
      const isValid = validAccessCodes.includes(value);
      setAccessCodeValid(isValid);
    }
  };

  const handleStep1InputChange = (field, value) => {
    setStep1Data(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user makes selection
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleStep2InputChange = (field, value) => {
    setStep2Data(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user makes selection
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleStep3InputChange = (field, value) => {
    setStep3Data(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user makes selection
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleStep4InputChange = (field, value) => {
    setStep4Data(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user makes selection
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleStep5InputChange = (field, value) => {
    setStep5Data(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user makes selection
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleStep6InputChange = (field, value) => {
    setStep6Data(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user makes selection
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleStep7InputChange = (field, value) => {
    setStep7Data(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user makes selection
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleStep8InputChange = (field, value) => {
    setStep8Data(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user makes selection
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleStep9InputChange = (field, value) => {
    setStep9Data(prev => ({
      ...prev,
      [field]: value
    }));
    
    

    // Clear error when user makes selection
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleStep10InputChange = (field, value) => {
    setStep10Data(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user makes selection
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fname.trim()) {
      newErrors.fname = 'First name is required';
    }

    if (!formData.lname.trim()) {
      newErrors.lname = 'Last name is required';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email address is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData.confirmEmail.trim()) {
      newErrors.confirmEmail = 'Please confirm your email address';
    } else if (formData.email !== formData.confirmEmail) {
      newErrors.confirmEmail = 'Email addresses do not match';
    }

    if (!formData.accessCode.trim()) {
      newErrors.accessCode = 'Access code is required';
    } else if (!validAccessCodes.includes(formData.accessCode)) {
      newErrors.accessCode = 'Invalid access code';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep1 = () => {
    const newErrors = {};

    if (!step1Data.Position1) {
      newErrors.Position1 = 'Please select an option';
    }
    if (!step1Data.Position2) {
      newErrors.Position2 = 'Please select an option';
    }
    if (!step1Data.Position3) {
      newErrors.Position3 = 'Please select an option';
    }
    if (!step1Data.Position4) {
      newErrors.Position4 = 'Please select an option';
    }
    if (!step1Data.Position5) {
      newErrors.Position5 = 'Please select an option';
    }

    
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep2 = () => {
    const newErrors = {};

    if (!step2Data.Capability1) {
      newErrors.Capability1 = 'Please select an option';
    }
    if (!step2Data.Capability2) {
      newErrors.Capability2 = 'Please select an option';
    }
    if (!step2Data.Capability3) {
      newErrors.Capability3 = 'Please select an option';
    }
    if (!step2Data.Capability4) {
      newErrors.Capability4 = 'Please select an option';
    }
    if (!step2Data.Capability5) {
      newErrors.Capability5 = 'Please select an option';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep3 = () => {
    const newErrors = {};

    if (!step3Data.Channel1) {
      newErrors.Channel1 = 'Please select an option';
    }
    if (!step3Data.Channel2) {
      newErrors.Channel2 = 'Please select an option';
    }
    if (!step3Data.Channel3) {
      newErrors.Channel3 = 'Please select an option';
    }
    if (!step3Data.Channel4) {
      newErrors.Channel4 = 'Please select an option';
    }
    if (!step3Data.Channel5) {
      newErrors.Channel5 = 'Please select an option';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep4 = () => {
    const newErrors = {};

    if (!step4Data.Buyer1) {
      newErrors.Buyer1 = 'Please select an option';
    }
    if (!step4Data.Buyer2) {
      newErrors.Buyer2 = 'Please select an option';
    }
    if (!step4Data.Buyer3) {
      newErrors.Buyer3 = 'Please select an option';
    }
    if (!step4Data.Buyer4) {
      newErrors.Buyer4 = 'Please select an option';
    }
    if (!step4Data.Buyer5) {
      newErrors.Buyer5 = 'Please select an option';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep5 = () => {
    const newErrors = {};

    if (!step5Data.Communication1) {
      newErrors.Communication1 = 'Please select an option';
    }
    if (!step5Data.Communication2) {
      newErrors.Communication2 = 'Please select an option';
    }
    if (!step5Data.Communication3) {
      newErrors.Communication3 = 'Please select an option';
    }
    if (!step5Data.Communication4) {
      newErrors.Communication4 = 'Please select an option';
    }
    if (!step5Data.Communication5) {
      newErrors.Communication5 = 'Please select an option';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep6 = () => {
    const newErrors = {};

    if (!step6Data.Conversations1) {
      newErrors.Conversations1 = 'Please select an option';
    }
    if (!step6Data.Conversations2) {
      newErrors.Conversations2 = 'Please select an option';
    }
    if (!step6Data.Conversations3) {
      newErrors.Conversations3 = 'Please select an option';
    }
    if (!step6Data.Conversations4) {
      newErrors.Conversations4 = 'Please select an option';
    }
    if (!step6Data.Conversations5) {
      newErrors.Conversations5 = 'Please select an option';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep7 = () => {
    const newErrors = {};

    if (!step7Data.Product1) {
      newErrors.Product1 = 'Please select an option';
    }
    if (!step7Data.Product2) {
      newErrors.Product2 = 'Please select an option';
    }
    if (!step7Data.Product3) {
      newErrors.Product3 = 'Please select an option';
    }
    if (!step7Data.Product4) {
      newErrors.Product4 = 'Please select an option';
    }
    if (!step7Data.Product5) {
      newErrors.Product5 = 'Please select an option';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep8 = () => {
    const newErrors = {};

    if (!step8Data.Management1) {
      newErrors.Management1 = 'Please select an option';
    }
    if (!step8Data.Management2) {
      newErrors.Management2 = 'Please select an option';
    }
    if (!step8Data.Management3) {
      newErrors.Management3 = 'Please select an option';
    }
    if (!step8Data.Management4) {
      newErrors.Management4 = 'Please select an option';
    }
    if (!step8Data.Management5) {
      newErrors.Management5 = 'Please select an option';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep9 = () => {
    const newErrors = {};

    if (!step9Data.Service1) {
      newErrors.Service1 = 'Please select an option';
    }
    if (!step9Data.Service2) {
      newErrors.Service2 = 'Please select an option';
    }
    if (!step9Data.Service3) {
      newErrors.Service3 = 'Please select an option';
    }
    if (!step9Data.Service4) {
      newErrors.Service4 = 'Please select an option';
    }
    if (!step9Data.Service5) {
      newErrors.Service5 = 'Please select an option';
    }

    
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep10 = () => {
    const newErrors = {};

    if (!step10Data.Organisation1) {
      newErrors.Organisation1 = 'Please select an option';
    }
    if (!step10Data.Organisation2) {
      newErrors.Organisation2 = 'Please select an option';
    }
    if (!step10Data.Organisation3) {
      newErrors.Organisation3 = 'Please select an option';
    }
    if (!step10Data.Organisation4) {
      newErrors.Organisation4 = 'Please select an option';
    }
  

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleStep1Submit = async (e) => {
    e.preventDefault();
    
    if (!validateStep1()) {
      return;
    }

    setIsLoading(true);
    
    // Save step 1 data to localStorage
    const step1StorageData = {
      ...step1Data
    };
    console.log("CHECK STEP 1 SUBMIT", step1StorageData);
    // Get existing form data from localStorage
    const existingData = localStorage.getItem('survey_form_data');
    const allData = existingData ? JSON.parse(existingData) : {};
    
    // Merge step 1 data with existing data
    const updatedData = {
      ...allData,
      step1: step1StorageData
    };
    
    localStorage.setItem('survey_form_data', JSON.stringify(updatedData));
    console.log('💾 Step 1 data saved to localStorage:', step1StorageData);
    
    // Send data to API
    console.log('🚀 Sending Step 1 data to API...');
    await sendSurveyStepData(1, step1StorageData);
    
    // Simulate API call delay
    setTimeout(() => {
      setIsLoading(false);
      setCurrentStep(2);
      window.scrollTo(0, 0);
    }, 1000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setCurrentStep(2);
    }, 2000);
  };

  const handleStep2Submit = async (e) => {
    e.preventDefault();
    
    if (!validateStep2()) {
      return;
    }

    setIsLoading(true);
    
    // Save step 2 data to localStorage
    const step2StorageData = {
      ...step2Data
    };
    
    // Get existing form data from localStorage
    const existingData = localStorage.getItem('survey_form_data');
    const allData = existingData ? JSON.parse(existingData) : {};
    
    // Merge step 2 data with existing data
    const updatedData = {
      ...allData,
      step2: step2StorageData
    };
    
    localStorage.setItem('survey_form_data', JSON.stringify(updatedData));
    console.log('💾 Step 2 data saved to localStorage:', step2StorageData);
    
    

    // Send data to API
    console.log('🚀 Sending Step 2 data to API...');
    await sendSurveyStepData(2, step2StorageData);
    
    // Simulate API call delay
    setTimeout(() => {
      setIsLoading(false);
      setCurrentStep(3);
      window.scrollTo(0, 0);
    }, 1000);
  };

  const handleStep2Back = () => {
    setCurrentStep(1);
    window.scrollTo(0, 0);
  };

  const handleStep3Submit = async (e) => {
    e.preventDefault();
    
    if (!validateStep3()) {
      return;
    }

    setIsLoading(true);
    
    // Save step 3 data to localStorage
    const step3StorageData = {
      ...step3Data
    };
    
    // Get existing form data from localStorage
    const existingData = localStorage.getItem('survey_form_data');
    const allData = existingData ? JSON.parse(existingData) : {};
    
    // Merge step 3 data with existing data
    const updatedData = {
      ...allData,
      step3: step3StorageData
    };
    
    localStorage.setItem('survey_form_data', JSON.stringify(updatedData));
    console.log('💾 Step 3 data saved to localStorage:', step3StorageData);
    
    // Send data to API
    console.log('🚀 Sending Step 3 data to API...');
    await sendSurveyStepData(3, step3StorageData);
    
    // Simulate API call delay
    setTimeout(() => {
      setIsLoading(false);
      setCurrentStep(4);
      window.scrollTo(0, 0);
    }, 1000);
  };

  const handleStep3Back = () => {
    setCurrentStep(2);
    window.scrollTo(0, 0);
  };

  const handleStep4Submit = async (e) => {
    e.preventDefault();
    
    if (!validateStep4()) {
      return;
    }

    setIsLoading(true);
    
    // Save step 3 data to localStorage
    const step4StorageData = {
      ...step4Data
    };
    
    // Get existing form data from localStorage
    const existingData = localStorage.getItem('survey_form_data');
    const allData = existingData ? JSON.parse(existingData) : {};
    
    // Merge step 3 data with existing data
    const updatedData = {
      ...allData,
      step4: step4StorageData
    };
    
    localStorage.setItem('survey_form_data', JSON.stringify(updatedData));
    console.log('💾 Step 4 data saved to localStorage:', step4StorageData);
    
    // Send data to API
    console.log('🚀 Sending Step 4 data to API...');
    await sendSurveyStepData(4, step4StorageData);
    
    // Simulate API call delay
    setTimeout(() => {
      setIsLoading(false);
      setCurrentStep(5);
      window.scrollTo(0, 0);
    }, 1000);
  };

  const handleStep4Back = () => {
    setCurrentStep(3);
    window.scrollTo(0, 0);
  };

  const handleStep5Submit = async (e) => {
    e.preventDefault();
    
    if (!validateStep5()) {
      return;
    }

    setIsLoading(true);
    
    // Save step 5 data to localStorage
    const step5StorageData = {
      ...step5Data
    };
    
    // Get existing form data from localStorage
    const existingData = localStorage.getItem('survey_form_data');
    const allData = existingData ? JSON.parse(existingData) : {};
    
    // Merge step 3 data with existing data
    const updatedData = {
      ...allData,
      step5: step5StorageData
    };
    
    localStorage.setItem('survey_form_data', JSON.stringify(updatedData));
    console.log('💾 Step 5 data saved to localStorage:', step5StorageData);
    
    // Send data to API
    console.log('🚀 Sending Step 5 data to API...');
    await sendSurveyStepData(5, step5StorageData);
    
    // Simulate API call delay
    setTimeout(() => {
      setIsLoading(false);
      setCurrentStep(6);
      window.scrollTo(0, 0);
    }, 1000);
  };

  const handleStep5Back = () => {
    setCurrentStep(4);
    window.scrollTo(0, 0);
  };

  const handleStep6Submit = async (e) => {
    e.preventDefault();
    
    if (!validateStep6()) {
      return;
    }

    setIsLoading(true);
    
    // Save step 6 data to localStorage
    const step6StorageData = {
      ...step6Data
    };
    
    // Get existing form data from localStorage
    const existingData = localStorage.getItem('survey_form_data');
    const allData = existingData ? JSON.parse(existingData) : {};
    
    // Merge step 3 data with existing data
    const updatedData = {
      ...allData,
      step6: step6StorageData
    };
    
    localStorage.setItem('survey_form_data', JSON.stringify(updatedData));
    console.log('💾 Step 6 data saved to localStorage:', step6StorageData);
    
    // Send data to API
    console.log('🚀 Sending Step 6 data to API...');
    await sendSurveyStepData(6, step6StorageData);
    
    // Simulate API call delay
    setTimeout(() => {
      setIsLoading(false);
      setCurrentStep(7);
      window.scrollTo(0, 0);
    }, 1000);
  };

  const handleStep6Back = () => {
    setCurrentStep(5);
    window.scrollTo(0, 0);
  };

  const handleStep7Submit = async (e) => {
    e.preventDefault();
    
    if (!validateStep7()) {
      return;
    }

    setIsLoading(true);
    
    // Save step 6 data to localStorage
    const step7StorageData = {
      ...step7Data
    };
    
    // Get existing form data from localStorage
    const existingData = localStorage.getItem('survey_form_data');
    const allData = existingData ? JSON.parse(existingData) : {};
    
    // Merge step 3 data with existing data
    const updatedData = {
      ...allData,
      step7: step7StorageData
    };
    
    localStorage.setItem('survey_form_data', JSON.stringify(updatedData));
    console.log('💾 Step 7 data saved to localStorage:', step7StorageData);
    
    // Send data to API
    console.log('🚀 Sending Step 7 data to API...');
    await sendSurveyStepData(7, step7StorageData);
    
    // Simulate API call delay
    setTimeout(() => {
      setIsLoading(false);
      setCurrentStep(8);
      window.scrollTo(0, 0);
    }, 1000);
  };

  const handleStep7Back = () => {
    setCurrentStep(6);
    window.scrollTo(0, 0);
  };

  const handleStep8Submit = async (e) => {
    e.preventDefault();
    
    if (!validateStep8()) {
      return;
    }

    setIsLoading(true);
    
    // Save step 6 data to localStorage
    const step8StorageData = {
      ...step8Data
    };
    
    // Get existing form data from localStorage
    const existingData = localStorage.getItem('survey_form_data');
    const allData = existingData ? JSON.parse(existingData) : {};
    
    // Merge step 3 data with existing data
    const updatedData = {
      ...allData,
      step8: step8StorageData
    };
    
    localStorage.setItem('survey_form_data', JSON.stringify(updatedData));
    console.log('💾 Step 8 data saved to localStorage:', step8StorageData);
    
    // Send data to API
    console.log('🚀 Sending Step 8 data to API...');
    await sendSurveyStepData(8, step8StorageData);
    
    // Simulate API call delay
    setTimeout(() => {
      setIsLoading(false);
      setCurrentStep(9);
      window.scrollTo(0, 0);
    }, 1000);
  };

  const handleStep8Back = () => {
    setCurrentStep(7);
    window.scrollTo(0, 0);
  };
  
  const handleStep9Submit = async (e) => {
    e.preventDefault();
    
    if (!validateStep9()) {
      return;
    }

    setIsLoading(true);
    
    // Save step 9 data to localStorage
    const step9StorageData = {
      ...step9Data
    };
    
    // Get existing form data from localStorage
    const existingData = localStorage.getItem('survey_form_data');
    const allData = existingData ? JSON.parse(existingData) : {};
    
    // Merge step 3 data with existing data
    const updatedData = {
      ...allData,
      step9: step9StorageData
    };
    
    localStorage.setItem('survey_form_data', JSON.stringify(updatedData));
    console.log('💾 Step 9 data saved to localStorage:', step9StorageData);
    
    // Send data to API
    console.log('🚀 Sending Step 9 data to API...');
    await sendSurveyStepData(9, step9StorageData);
    
    // Simulate API call delay
    setTimeout(() => {
      setIsLoading(false);
      setCurrentStep(10);
      window.scrollTo(0, 0);
    }, 1000);
  };

  const handleStep9Back = () => {
    setCurrentStep(8);
    window.scrollTo(0, 0);
  };

  const handleStep10Submit = async (e) => {
    e.preventDefault();
    console.log('🔍 step10Data:', step10Data);
    if (!validateStep10()) {
      return;
    }

    setIsLoading(true);
    
    // Save step 10 data to localStorage
    const step10StorageData = {
      ...step10Data
    };
    
    // Get existing form data from localStorage
    const existingData = localStorage.getItem('survey_form_data');
    const allData = existingData ? JSON.parse(existingData) : {};
    
    // Merge step 3 data with existing data
    const updatedData = {
      ...allData,
      step10: step10StorageData
    };
    
    localStorage.setItem('survey_form_data', JSON.stringify(updatedData));
    console.log('💾 Step 10 data saved to localStorage:', step10StorageData);
    
    // Send data to API
    console.log('🚀 Sending Step 10 data to API...');
    await sendSurveyStepData(10, step10StorageData);
    
    // Simulate API call delay
    setTimeout(() => {
      setIsLoading(false);
      setCurrentStep(11);
      window.scrollTo(0, 0);
    }, 1000);
  };

  const handleStep10Back = () => {
    setCurrentStep(9);
    window.scrollTo(0, 0);
  };

  const startQuestionnaire = () => {
    // Get session data from localStorage
    getSessionData();
    setCurrentStep(4);
    window.scrollTo(0, 0);
  };

  const handleAssessmentComplete = (answers) => {
    // Calculate MSQ Index score (1-5 scale, average of all answers)
    const totalScore = Object.values(answers).reduce((sum, score) => sum + score, 0);
    const averageScore = totalScore / Object.keys(answers).length;
    
    setAssessmentResults({
      answers,
      score: averageScore,
      totalQuestions: Object.keys(answers).length
    });
    
    setCurrentStep(4);
    window.scrollTo(0, 0);
  };

  const handleBackToInstructions = () => {
    setCurrentStep(2);
    window.scrollTo(0, 0);
  };

  const answerStep = (type = 'position') => {
    
    return (
      <>
        <style dangerouslySetInnerHTML={{__html: `
            .first-row.position td.first {
                background-color: #000000;
            }
            .first-row.capability td.second {
                background-color: #000000;
            }
            .first-row.channel td.third {
                background-color: #000000;
            }

            .first-row.all td.first {
                background-color: #000000;
            }
            .first-row.all td.second {
                background-color: #000000;
            }
            .first-row.all td.third {
                background-color: #000000;
            }

            .second-row.buyers td.first {
                background-color: #545454;
            }
            .second-row.communication td.second {
                background-color: #545454;
            }
            .second-row.conversation td.third {
                background-color: #545454;
            }

            .second-row.all td.first {
                background-color: #545454;
            }
            .second-row.all td.second {
                background-color: #545454;
            }
            .second-row.all td.third {
                background-color: #545454;
            }
                
            .third-row.products td.first {
                background-color: #a6a6a6;
            }
            .third-row.management td.second {
                background-color: #a6a6a6;
            }
            .third-row.services td.third {
                background-color: #a6a6a6;
            }

            .third-row.all td.first {
                background-color: #a6a6a6;
            }
            .third-row.all td.second {
                background-color: #a6a6a6;
            }
            .third-row.all td.third {
                background-color: #a6a6a6;
            }

            table.cube tr td {
                border: 1px solid #000 !important;
                padding: 20px;
                border-radius: 100px !important;
                height: 10px;
                width: 10px;
                margin: 3px;
                display: inline-flex;
            }
            table {
                float: right;
                top: -40px;
                position: relative;
            }
            h1 {
                display: inline;
            }
            
        `}} />
        <table className="cube">
            <tr className={`first-row ${type}`}>
                <td className="first"></td><td className="second"></td><td className="third"></td>
            </tr>
            <tr className={`second-row ${type}`}>
                <td className="first"></td><td className="second"></td><td className="third"></td>
            </tr>
            <tr className={`third-row ${type}`}>
                <td className="first"></td><td className="second"></td><td className="third"></td>
            </tr>
        </table>
      </>
    );
  };

  //Question 1 - Position
  if (currentStep === 1) {
    return (
      <div className="min-h-screen bg-gradient-to-br to-indigo-100">
        {/* Header */}

        {/* Hero Section */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6" style={{display: 'inline'}}>
              POSITION
            </h1>
            {answerStep('position')}

            
              <div className="bg-white p-8 w-full mx-auto mt-20">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 text-left">What makes you different to your competitors?</h2>
                <p className="text-gray-600 mb-8 text-left">
                Position is the foundation of revenue-generating activity - get this right and everything else will fall into place more easily. You will have a focus on all of your marketing decisions.
                </p>
                
                <h5 className="text-1xl font-bold text-gray-900 mb-2 text-left">
                What is considered to be best practice in POSITION?
                </h5>
                <ol className="list-decimal list-inside text-gray-600 mb-8 text-left">
                  <li>You've developed a market strategy.</li>
                  <li>Your business plan is current and relevant.</li>
                  <li>You know your current market position.</li>
                  <li>You've documented your vision and values.</li>
                  <li>Market, service, product and price strategies are all documented.</li>
                </ol>
                
                <form onSubmit={handleStep1Submit} className="space-y-8">
                  {/* Question 1 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                      1. Have you recently reviewed and defined your position?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position1"
                          value="2"
                          checked={step1Data.Position1 === '2'}
                          onChange={(e) => handleStep1InputChange('Position1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position1"
                          value="1"
                          checked={step1Data.Position1 === '1'}
                          onChange={(e) => handleStep1InputChange('Position1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position1"
                          value="0"
                          checked={step1Data.Position1 === '0'}
                          onChange={(e) => handleStep1InputChange('Position1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                      
                    </div>
                    
                    {errors.Position1 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Position1}
                      </p>
                    )}
                  </div>

                  {/* Question 2 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    2. Do you feel your business has an integral understanding of its position?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position2"
                          value="2"
                          checked={step1Data.Position2 === '2'}
                          onChange={(e) => handleStep1InputChange('Position2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position2"
                          value="1"
                          checked={step1Data.Position2 === '1'}
                          onChange={(e) => handleStep1InputChange('Position2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position2"
                          value="0"
                          checked={step1Data.Position2 === '0'}
                          onChange={(e) => handleStep1InputChange('Position2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Position2 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Position2}
                      </p>
                    )}
                  </div>


                  {/* Question 3 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    3. Are your stakeholders clear about your market position?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position3"
                          value="2"
                          checked={step1Data.Position3 === '2'}
                          onChange={(e) => handleStep1InputChange('Position3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position3"
                          value="1"
                          checked={step1Data.Position3 === '1'}
                          onChange={(e) => handleStep1InputChange('Position3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position3"
                          value="0"
                          checked={step1Data.Position3 === '0'}
                          onChange={(e) => handleStep1InputChange('Position3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Position3 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Position3}
                      </p>
                    )}
                  </div>

                  {/* Question 4 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    4. Does your business have a business plan?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position4"
                          value="2"
                          checked={step1Data.Position4 === '2'}
                          onChange={(e) => handleStep1InputChange('Position4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position4"
                          value="1"
                          checked={step1Data.Position4 === '1'}
                          onChange={(e) => handleStep1InputChange('Position4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position4"
                          value="0"
                          checked={step1Data.Position4 === '0'}
                          onChange={(e) => handleStep1InputChange('Position4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Position4 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Position4}
                      </p>
                    )}
                  </div>

                  {/* Question 5 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    5. Does your business understand its operating markets?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position5"
                          value="2"
                          checked={step1Data.Position5 === '2'}
                          onChange={(e) => handleStep1InputChange('Position5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position5"
                          value="1"
                          checked={step1Data.Position5 === '1'}
                          onChange={(e) => handleStep1InputChange('Position5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Position5"
                          value="0"
                          checked={step1Data.Position5 === '0'}
                          onChange={(e) => handleStep1InputChange('Position5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Position5 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Position5}
                      </p>
                    )}
                  </div>

                  
                  
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="w-full bg-indigo-600 text-white py-3 px-6 rounded-md font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                  >
                    {isLoading ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                        Processing...
                      </>
                    ) : (
                      <>
                        NEXT
                        <ArrowRight className="ml-2 h-5 w-5" />
                      </>
                    )}
                  </button>
                </form>
              </div>
          </div>
        </section>

      </div>
    );
  }

  //CAPABILITY
  if (currentStep === 2) {
    return (
      <div className="min-h-screen bg-gradient-to-br to-indigo-100">
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            CAPABILITY
            </h1>
            {answerStep('capability')}
              <div className="bg-white p-8 w-full mx-auto mt-20">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 text-left">
                  Does your business have a functional marketing resource?  
                </h2>
                <p className="text-gray-600 mb-8 text-left">
                Capability is all about your marketing 'engine room' - the people, functional structures and processes, budgets and other resources. It is also about those resources your business chooses to outsource - not all businesses need everything to be internal.
                </p>
                <h5 className="text-1xl font-bold text-gray-900 mb-2 text-left">
                What is considered to be best practice in CAPABILITY?
                </h5>
                <ol className="list-decimal list-inside text-gray-600 mb-8 text-left">
                  <li>You have a marketing strategy and communication plan.</li>
                  <li>Tools are in place to measure your marketing.</li>
                  <li>Your marketing people can help your business grow to the next stage.</li>
                  <li>Your marketing people know what's next for your business.</li>
                  <li>You're sticking to a well-defined marketing budget.</li>
                </ol>
               
                <form onSubmit={handleStep2Submit} className="space-y-8">
                  {/* Question 1 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                      1. Has the marketing you’ve done to date achieved measurable results?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Capability1"
                          value="2"
                          checked={step2Data.Capability1 === '2'}
                          onChange={(e) => handleStep2InputChange('Capability1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio" 
                          name="Capability1"
                          value="1"
                          checked={step2Data.Capability1 === '1'}
                          onChange={(e) => handleStep2InputChange('Capability1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Capability1"
                          value="0"
                          checked={step2Data.Capability1 === '0'}
                          onChange={(e) => handleStep2InputChange('Capability1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                      
                    </div>
                    
                    {errors.Capability1 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Capability1}
                      </p>
                    )}
                  </div>

                  {/* Question 2 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    2. Do you have the right level of marketing functionality in your business for now and future growth?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Capability2"
                          value="2"
                          checked={step2Data.Capability2 === '2'}
                          onChange={(e) => handleStep2InputChange('Capability2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Capability2"
                          value="1"
                          checked={step2Data.Capability2 === '1'}
                          onChange={(e) => handleStep2InputChange('Capability2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Capability2"
                          value="0"
                          checked={step2Data.Capability2 === '0'}
                          onChange={(e) => handleStep2InputChange('Capability2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Capability2 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Capability2}
                      </p>
                    )}
                  </div>


                  {/* Question 3 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    3. Does your marketing team have a clear reporting structure, up and down the line?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Capability3"
                          value="2"
                          checked={step2Data.Capability3 === '2'}
                          onChange={(e) => handleStep2InputChange('Capability3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Capability3"
                          value="1"
                          checked={step2Data.Capability3 === '1'}
                          onChange={(e) => handleStep2InputChange('Capability3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Capability3"
                          value="0"
                          checked={step2Data.Capability3 === '0'}
                          onChange={(e) => handleStep2InputChange('Capability3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Capability3 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Capability3}
                      </p>
                    )}
                  </div>

                  {/* Question 4 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    4. Does your marketing team understand your business issues and targets for the next year?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Capability4"
                          value="2"
                          checked={step2Data.Capability4 === '2'}
                          onChange={(e) => handleStep2InputChange('Capability4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Capability4"
                          value="1"
                          checked={step2Data.Capability4 === '1'}
                          onChange={(e) => handleStep2InputChange('Capability4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Capability4"
                          value="0"
                          checked={step2Data.Capability4 === '0'}
                          onChange={(e) => handleStep2InputChange('Capability4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Capability4 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Capability4}
                      </p>
                    )}
                  </div>

                  {/* Question 5 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    5. Do you have a marketing budget?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Capability5"
                          value="2"
                          checked={step2Data.Capability5 === '2'}
                          onChange={(e) => handleStep2InputChange('Capability5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Capability5"
                          value="1"
                          checked={step2Data.Capability5 === '1'}
                          onChange={(e) => handleStep2InputChange('Capability5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Capability5"
                          value="0"
                          checked={step2Data.Capability5 === '0'}
                          onChange={(e) => handleStep2InputChange('Capability5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Capability5 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Capability5}
                      </p>
                    )}
                  </div>

                  
                  
                  <div className="flex gap-4">
                    <button
                      type="button"
                      onClick={handleStep2Back}
                      className="flex-1 bg-gray-500 text-white py-3 px-6 rounded-md font-medium hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 flex items-center justify-center"
                    >
                      <ArrowRight className="mr-2 h-5 w-5 rotate-180" />
                      BACK
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="flex-1 bg-indigo-600 text-white py-3 px-6 rounded-md font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                    >
                      {isLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                          Processing...
                        </>
                      ) : (
                        <>
                          NEXT
                          <ArrowRight className="ml-2 h-5 w-5" />
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
          </div>
        </section>

      </div>
    );
  }

  //Question 3 - Channel
  if (currentStep === 3) {
    return (
      <div className="min-h-screen bg-gradient-to-br to-indigo-100">
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            CHANNEL
            </h1>
            {answerStep('channel')}
              <div className="bg-white p-8 w-full mx-auto mt-20">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 text-left">
                Do you know which channels give you access to your clients?
                </h2>
                <p className="text-gray-600 mb-8 text-left">
                Channel is all about how you source new business. These could be third party relationships, often referred to as 'word of mouth' and/or traditional marketing channels, such as digital marketing, advertising, PR etc.
                </p>
                <h5 className="text-1xl font-bold text-gray-900 mb-2 text-left">
                What is considered to be best practice in CHANNEL?
                </h5>
                <ol className="list-decimal list-inside text-gray-600 mb-8 text-left">
                  <li>You know and measure the channels that deliver work to your business.</li>
                  <li>All of your channels have KPIs.</li>
                  <li>You're actively seeking new channels.</li>
                  <li>Every channel has a documented communications program.</li>
                  <li>You regularly review and refresh your communications programs.</li>
                </ol>
                
                <form onSubmit={handleStep3Submit} className="space-y-8">
                  {/* Question 1 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    1. Do you understand the most effective channels and partnerships that supply business to your company?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel1"
                          value="2"
                          checked={step3Data.Channel1 === '2'}
                          onChange={(e) => handleStep3InputChange('Channel1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel1"
                          value="1"
                          checked={step3Data.Channel1 === '1'}
                          onChange={(e) => handleStep3InputChange('Channel1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel1"
                          value="0"
                          checked={step3Data.Channel1 === '0'}
                          onChange={(e) => handleStep3InputChange('Channel1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Channel1 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Channel1}
                      </p>
                    )}
                  </div>

                  {/* Question 2 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    2. Do you regularly measure the effectiveness of those channels and partners?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel2"
                          value="2"
                          checked={step3Data.Channel2 === '2'}
                          onChange={(e) => handleStep3InputChange('Channel2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel2"
                          value="1"
                          checked={step3Data.Channel2 === '1'}
                          onChange={(e) => handleStep3InputChange('Channel2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel2"
                          value="0"
                          checked={step3Data.Channel2 === '0'}
                          onChange={(e) => handleStep3InputChange('Channel2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Channel2 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Channel2}
                      </p>
                    )}
                  </div>

                  {/* Question 3 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    3. Did you actively seek them?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel3"
                          value="2"
                          checked={step3Data.Channel3 === '2'}
                          onChange={(e) => handleStep3InputChange('Channel3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel3"
                          value="1"
                          checked={step3Data.Channel3 === '1'}
                          onChange={(e) => handleStep3InputChange('Channel3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel3"
                          value="0"
                          checked={step3Data.Channel3 === '0'}
                          onChange={(e) => handleStep3InputChange('Channel3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Channel3 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Channel3}
                      </p>
                    )}
                  </div>

                  {/* Question 4 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    4. Are you convinced they are the most effective ones for your business?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel4"
                          value="2"
                          checked={step3Data.Channel4 === '2'}
                          onChange={(e) => handleStep3InputChange('Channel4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel4"
                          value="1"
                          checked={step3Data.Channel4 === '1'}
                          onChange={(e) => handleStep3InputChange('Channel4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel4"
                          value="0"
                          checked={step3Data.Channel4 === '0'}
                          onChange={(e) => handleStep3InputChange('Channel4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Channel4 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Channel4}
                      </p>
                    )}
                  </div>

                  {/* Question 5 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    5. Do you regularly communicate and manage those channels and partners?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel5"
                          value="2"
                          checked={step3Data.Channel5 === '2'}
                          onChange={(e) => handleStep3InputChange('Channel5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it’s working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel5"
                          value="1"
                          checked={step3Data.Channel5 === '1'}
                          onChange={(e) => handleStep3InputChange('Channel5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It’s work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Channel5"
                          value="0"
                          checked={step3Data.Channel5 === '0'}
                          onChange={(e) => handleStep3InputChange('Channel5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.s</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Channel5 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Channel5}
                      </p>
                    )}
                  </div>
                  
                  <div className="flex gap-4">
                    <button
                      type="button"
                      onClick={handleStep3Back}
                      className="flex-1 bg-gray-500 text-white py-3 px-6 rounded-md font-medium hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 flex items-center justify-center"
                    >
                      <ArrowRight className="mr-2 h-5 w-5 rotate-180" />
                      BACK
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="flex-1 bg-indigo-600 text-white py-3 px-6 rounded-md font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                    >
                      {isLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                          Processing...
                        </>
                      ) : (
                        <>
                          NEXT
                          <ArrowRight className="ml-2 h-5 w-5" />
                        </>
                      )}
                    </button>
                  </div>
                </form>
                </div>
          </div>
        </section>

      </div>
    );
  }


  //Question 4 - Buyer's Journey
  if (currentStep === 4) {
    return (
      <div className="min-h-screen bg-gradient-to-br to-indigo-100">
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            BUYER'S JOURNEY
            </h1>
            {answerStep('buyers')}
              <div className="bg-white p-8 w-full mx-auto mt-20">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 text-left">
                What makes them buy from you?
                </h2>
                <p className="text-gray-600 mb-8 text-left">
                Buyer's Journey is all about understanding what makes your stakeholders engage with your business. If you understand the path to engagement you are in a better position to influence them more effectively, potentially converting more leads into revenue.
                </p>
                <h5 className="text-1xl font-bold text-gray-900 mb-2 text-left">
                What's best practice in BUYER'S JOURNEY?
                </h5>
                <ol className="list-decimal list-inside text-gray-600 mb-8 text-left">
                  <li>You're clear about how every client has bought from you.</li>
                  <li>You understand how many touch points it takes until someone buys from you.</li>
                  <li>Marketing communication is focused on the ultimate goal: sales.</li>
                  <li>Your regular insights program means you speak to your customers frequently.</li>
                  <li>You regularly review what your competitors are offering.</li>
                </ol>

                
                <form onSubmit={handleStep4Submit} className="space-y-8">
                  {/* Question 1 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    1. Do you know how your clients buy from you?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer1"
                          value="2"
                          checked={step4Data.Buyer1 === '2'}
                          onChange={(e) => handleStep4InputChange('Buyer1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer1"
                          value="1"
                          checked={step4Data.Buyer1 === '1'}
                          onChange={(e) => handleStep4InputChange('Buyer1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer1"
                          value="0"
                          checked={step4Data.Buyer1 === '0'}
                          onChange={(e) => handleStep4InputChange('Buyer1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Buyer1 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Buyer1}
                      </p>
                    )}
                  </div>

                  {/* Question 2 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    2. Are you aware of how many touchpoints you have with your clients before they purchase from your business?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer2"
                          value="2"
                          checked={step4Data.Buyer2 === '2'}
                          onChange={(e) => handleStep4InputChange('Buyer2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer2"
                          value="1"
                          checked={step4Data.Buyer2 === '1'}
                          onChange={(e) => handleStep4InputChange('Buyer2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer2"
                          value="0"
                          checked={step4Data.Buyer2 === '0'}
                          onChange={(e) => handleStep4InputChange('Buyer2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Buyer2 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Buyer2}
                      </p>
                    )}
                  </div>

                  {/* Question 3 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    3. Does your marketing communication activity support the buying process of your clients?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer3"
                          value="2"
                          checked={step4Data.Buyer3 === '2'}
                          onChange={(e) => handleStep4InputChange('Buyer3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer3"
                          value="1"
                          checked={step4Data.Buyer3 === '1'}
                          onChange={(e) => handleStep4InputChange('Buyer3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer3"
                          value="0"
                          checked={step4Data.Buyer3 === '0'}
                          onChange={(e) => handleStep4InputChange('Buyer3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Buyer3 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Buyer3}
                      </p>
                    )}
                  </div>

                  {/* Question 4 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    4. Have you asked your clients how and why they buy from you?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer4"
                          value="2"
                          checked={step4Data.Buyer4 === '2'}
                          onChange={(e) => handleStep4InputChange('Buyer4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer4"
                          value="1"
                          checked={step4Data.Buyer4 === '1'}
                          onChange={(e) => handleStep4InputChange('Buyer4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer4"
                          value="0"
                          checked={step4Data.Buyer4 === '0'}
                          onChange={(e) => handleStep4InputChange('Buyer4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Buyer4 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Buyer4}
                      </p>
                    )}
                  </div>

                  {/* Question 5 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    5. Do you understand why they buy from you rather than your competitors and vice versa?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer5"
                          value="2"
                          checked={step4Data.Buyer5 === '2'}
                          onChange={(e) => handleStep4InputChange('Buyer5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer5"
                          value="1"
                          checked={step4Data.Buyer5 === '1'}
                          onChange={(e) => handleStep4InputChange('Buyer5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Buyer5"
                          value="0"
                          checked={step4Data.Buyer5 === '0'}
                          onChange={(e) => handleStep4InputChange('Buyer5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Buyer5 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Buyer5}
                      </p>
                    )}
                  </div>
                  
                  <div className="flex gap-4">
                    <button
                      type="button"
                      onClick={handleStep4Back}
                      className="flex-1 bg-gray-500 text-white py-3 px-6 rounded-md font-medium hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 flex items-center justify-center"
                    >
                      <ArrowRight className="mr-2 h-5 w-5 rotate-180" />
                      BACK
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="flex-1 bg-indigo-600 text-white py-3 px-6 rounded-md font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                    >
                      {isLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                          Processing...
                        </>
                      ) : (
                        <>
                          NEXT
                          <ArrowRight className="ml-2 h-5 w-5" />
                        </>
                      )}
                    </button>
                  </div>
                </form>
                </div>
          </div>
        </section>
      </div>
    );
  }

  //Question 5 - COMMUNICATION
  if (currentStep === 5) {
    return (
      <div className="min-h-screen bg-gradient-to-br to-indigo-100">
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            COMMUNICATION
            </h1>
            {answerStep('communication')}
              <div className="bg-white p-8 w-full mx-auto mt-20">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 text-left">
                Does your business have a consistent language?
                </h2>
                <p className="text-gray-600 mb-8 text-left">
                Communication is all about the language, messages and materials your business uses to communicate with the stakeholders in your business - internally and externally. You need to ensure they are consistent and represent the feeling in your business.
                </p>
                <h5 className="text-1xl font-bold text-gray-900 mb-2 text-left">
                What's best practice in COMMUNICATION?
                </h5>
                <ol className="list-decimal list-inside text-gray-600 mb-8 text-left">
                <li>You have a stakeholder engagement matrix.</li>
                <li>Your communication material delivers your position.</li>
                <li>Brand values are evident throughout your internal and external communications.</li>
                <li>You're always talking about your customers, not your business.</li>
                <li>You regularly review and update your marketing materials.</li>
                </ol>
                
                <form onSubmit={handleStep5Submit} className="space-y-8">
                  {/* Question 1 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    1. Do you have a consistent approach to your messaging?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication1"
                          value="2"
                          checked={step5Data.Communication1 === '2'}
                          onChange={(e) => handleStep5InputChange('Communication1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication1"
                          value="1"
                          checked={step5Data.Communication1 === '1'}
                          onChange={(e) => handleStep5InputChange('Communication1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication1"
                          value="0"
                          checked={step5Data.Communication1 === '0'}
                          onChange={(e) => handleStep5InputChange('Communication1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Communication1 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Communication1}
                      </p>
                    )}
                  </div>

                  {/* Question 2 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    2. Do you have a clear and consistent language pattern?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication2"
                          value="2"
                          checked={step5Data.Communication2 === '2'}
                          onChange={(e) => handleStep5InputChange('Communication2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication2"
                          value="1"
                          checked={step5Data.Communication2 === '1'}
                          onChange={(e) => handleStep5InputChange('Communication2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication2"
                          value="0"
                          checked={step5Data.Communication2 === '0'}
                          onChange={(e) => handleStep5InputChange('Communication2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Communication2 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Communication2}
                      </p>
                    )}
                  </div>

                  {/* Question 3 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    3. Do your customers understand the benefits of Yes, it’s working. with your business?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication3"
                          value="2"
                          checked={step5Data.Communication3 === '2'}
                          onChange={(e) => handleStep5InputChange('Communication3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication3"
                          value="1"
                          checked={step5Data.Communication3 === '1'}
                          onChange={(e) => handleStep5InputChange('Communication3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication3"
                          value="0"
                          checked={step5Data.Communication3 === '0'}
                          onChange={(e) => handleStep5InputChange('Communication3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Communication3 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Communication3}
                      </p>
                    )}
                  </div>

                  {/* Question 4 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    4. Does your brand identity represent the feeling of your business?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication4"
                          value="2"
                          checked={step5Data.Communication4 === '2'}
                          onChange={(e) => handleStep5InputChange('Communication4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication4"
                          value="1"
                          checked={step5Data.Communication4 === '1'}
                          onChange={(e) => handleStep5InputChange('Communication4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication4"
                          value="0"
                          checked={step5Data.Communication4 === '0'}
                          onChange={(e) => handleStep5InputChange('Communication4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Communication4 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Communication4}
                      </p>
                    )}
                  </div>

                  {/* Question 5 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    5. Does your business have a consistent and effective suite of marketing materials?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication5"
                          value="2"
                          checked={step5Data.Communication5 === '2'}
                          onChange={(e) => handleStep5InputChange('Communication5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication5"
                          value="1"
                          checked={step5Data.Communication5 === '1'}
                          onChange={(e) => handleStep5InputChange('Communication5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Communication5"
                          value="0"
                          checked={step5Data.Communication5 === '0'}
                          onChange={(e) => handleStep5InputChange('Communication5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Communication5 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Communication5}
                      </p>
                    )}
                  </div>
                  
                  <div className="flex gap-4">
                    <button
                      type="button"
                      onClick={handleStep5Back}
                      className="flex-1 bg-gray-500 text-white py-3 px-6 rounded-md font-medium hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 flex items-center justify-center"
                    >
                      <ArrowRight className="mr-2 h-5 w-5 rotate-180" />
                      BACK
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="flex-1 bg-indigo-600 text-white py-3 px-6 rounded-md font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                    >
                      {isLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                          Processing...
                        </>
                      ) : (
                        <>
                          NEXT
                          <ArrowRight className="ml-2 h-5 w-5" />
                        </>
                      )}
                    </button>
                  </div>
                </form>
                </div>
          </div>
        </section>
      </div>
    );
  }

  //Question 6 - STARTING CONVERSATION
  if (currentStep === 6) {
    return (
      <div className="min-h-screen bg-gradient-to-br to-indigo-100">
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            STARTING CONVERSATION
            </h1>
            {answerStep('conversation')}
              <div className="bg-white p-8 w-full mx-auto mt-20">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 text-left">
                How does your business measure sales performance?
                </h2>
                <p className="text-gray-600 mb-8 text-left">
                Starting Conversations is all about how your business nurtures and converts lead into sales. Your business needs to understand how your customers buy from you in order to maximise their conversion opportunity.
                </p>
                <h5 className="text-1xl font-bold text-gray-900 mb-2 text-left">
                What’s best practice in STARTING CONVERSATIONS?
                </h5>
                <ol className="list-decimal list-inside text-gray-600 mb-8 text-left">
                  <li>Your sales strategy and process are fully understood and used by your business.</li>
                  <li>Your business has the right, fully trained sales staff.</li>
                  <li>Marketing and sales are working together.</li>
                  <li>Your tools support your sales strategy.</li>
                  <li>Budgets are in place and you hold regular sales meetings.</li>
                </ol>
                
                <form onSubmit={handleStep6Submit} className="space-y-8">
                  {/* Question 1 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    1. Do you have a clear sales strategy that is communicated and executed throughout?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations1"
                          value="2"
                          checked={step6Data.Conversations1 === '2'}
                          onChange={(e) => handleStep6InputChange('Conversations1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations1"
                          value="1"
                          checked={step6Data.Conversations1 === '1'}
                          onChange={(e) => handleStep6InputChange('Conversations1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations1"
                          value="0"
                          checked={step6Data.Conversations1 === '0'}
                          onChange={(e) => handleStep6InputChange('Conversations1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Conversations1 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Conversations1}
                      </p>
                    )}
                  </div>

                  {/* Question 2 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    2. Do your sales managers have the capability and skills to execute your strategy through their people?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations2"
                          value="2"
                          checked={step6Data.Conversations2 === '2'}
                          onChange={(e) => handleStep6InputChange('Conversations2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations2"
                          value="1"
                          checked={step6Data.Conversations2 === '1'}
                          onChange={(e) => handleStep6InputChange('Conversations2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations2"
                          value="0"
                          checked={step6Data.Conversations2 === '0'}
                          onChange={(e) => handleStep6InputChange('Conversations2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Conversations2 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Conversations2}
                      </p>
                    )}
                  </div>

                  {/* Question 3 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    3. Does your business have a well-defined pipeline process and understand its sales opportunities?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations3"
                          value="2"
                          checked={step6Data.Conversations3 === '2'}
                          onChange={(e) => handleStep6InputChange('Conversations3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations3"
                          value="1"
                          checked={step6Data.Conversations3 === '1'}
                          onChange={(e) => handleStep6InputChange('Conversations3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations3"
                          value="0"
                          checked={step6Data.Conversations3 === '0'}
                          onChange={(e) => handleStep6InputChange('Conversations3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Conversations3 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Conversations3}
                      </p>
                    )}
                  </div>

                  {/* Question 4 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    4. Do you have a clear sales methodology and supporting sales tools?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations4"
                          value="2"
                          checked={step6Data.Conversations4 === '2'}
                          onChange={(e) => handleStep6InputChange('Conversations4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations4"
                          value="1"
                          checked={step6Data.Conversations4 === '1'}
                          onChange={(e) => handleStep6InputChange('Conversations4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations4"
                          value="0"
                          checked={step6Data.Conversations4 === '0'}
                          onChange={(e) => handleStep6InputChange('Conversations4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Conversations4 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Conversations4}
                      </p>
                    )}
                  </div>

                  {/* Question 5 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    5. Does your sales team consistently achieve budget?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations5"
                          value="2"
                          checked={step6Data.Conversations5 === '2'}
                          onChange={(e) => handleStep6InputChange('Conversations5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations5"
                          value="1"
                          checked={step6Data.Conversations5 === '1'}
                          onChange={(e) => handleStep6InputChange('Conversations5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Conversations5"
                          value="0"
                          checked={step6Data.Conversations5 === '0'}
                          onChange={(e) => handleStep6InputChange('Conversations5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Conversations5 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Conversations5}
                      </p>
                    )}
                  </div>
                  
                  <div className="flex gap-4">
                    <button
                      type="button"
                      onClick={handleStep6Back}
                      className="flex-1 bg-gray-500 text-white py-3 px-6 rounded-md font-medium hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 flex items-center justify-center"
                    >
                      <ArrowRight className="mr-2 h-5 w-5 rotate-180" />
                      BACK
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="flex-1 bg-indigo-600 text-white py-3 px-6 rounded-md font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                    >
                      {isLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                          Processing...
                        </>
                      ) : (
                        <>
                          NEXT
                          <ArrowRight className="ml-2 h-5 w-5" />
                        </>
                      )}
                    </button>
                  </div>
                </form>
                </div>
          </div>
        </section>
      </div>
    );
  }
  
  //Question 7 - PRODUCT/SERVICE
  if (currentStep === 7) {
    return (
      <div className="min-h-screen bg-gradient-to-br to-indigo-100">
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            PRODUCT/SERVICE
            </h1>
            {answerStep('products')}
              <div className="bg-white p-8 w-full mx-auto mt-20">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 text-left">
                What are you selling?
                </h2>
                <p className="text-gray-600 mb-8 text-left">
                Product and services is one of the foundations of your revenue-generating activity. It needs to be kept under regular review helping your business keep up with changing market conditions. It's also the direct comparison that your customers have with your competitors.
                </p>
                <h5 className="text-1xl font-bold text-gray-900 mb-2 text-left">
                What’s best practice in PRODUCT/SERVICE?
                </h5>
                <ol className="list-decimal list-inside text-gray-600 mb-8 text-left">
                  <li>Everyone in the business knows why and how you sell what you do.</li>
                  <li>The product you sell is what your client wants to buy (value proposition).</li>
                  <li>You're always looking at how you can improve your offer to market.</li>
                  <li>Someone in your business is working on new product ideas.</li>
                  <li>You're watching your competitors.</li>
                </ol>
                
                <form onSubmit={handleStep7Submit} className="space-y-8">
                  {/* Question 1 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    1. Does everyone in your business understand the products and services that you offer?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product1"
                          value="2"
                          checked={step7Data.Product1 === '2'}
                          onChange={(e) => handleStep7InputChange('Product1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product1"
                          value="1"
                          checked={step7Data.Product1 === '1'}
                          onChange={(e) => handleStep7InputChange('Product1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product1"
                          value="0"
                          checked={step7Data.Product1 === '0'}
                          onChange={(e) => handleStep7InputChange('Product1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Product1 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Product1}
                      </p>
                    )}
                  </div>


                  {/* Question 2 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    2. Are your products and services aligned with your position?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product2"
                          value="2"
                          checked={step7Data.Product2 === '2'}
                          onChange={(e) => handleStep7InputChange('Product2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product2"
                          value="1"
                          checked={step7Data.Product2 === '1'}
                          onChange={(e) => handleStep7InputChange('Product2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product2"
                          value="0"
                          checked={step7Data.Product2 === '0'}
                          onChange={(e) => handleStep7InputChange('Product2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Product2 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Product2}
                      </p>
                    )}
                  </div>

                  {/* Question 3 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    3. Does your business regularly review what you put into the marketplace?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product3"
                          value="2"
                          checked={step7Data.Product3 === '2'}
                          onChange={(e) => handleStep7InputChange('Product3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product3"
                          value="1"
                          checked={step7Data.Product3 === '1'}
                          onChange={(e) => handleStep7InputChange('Product3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product3"
                          value="0"
                          checked={step7Data.Product3 === '0'}
                          onChange={(e) => handleStep7InputChange('Product3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Product3 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Product3}
                      </p>
                    )}
                  </div>

                  {/* Question 4 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    4. Do you have someone in your business looking for new product/service ideas?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product4"
                          value="2"
                          checked={step7Data.Product4 === '2'}
                          onChange={(e) => handleStep7InputChange('Product4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product4"
                          value="1"
                          checked={step7Data.Product4 === '1'}
                          onChange={(e) => handleStep7InputChange('Product4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product4"
                          value="0"
                          checked={step7Data.Product4 === '0'}
                          onChange={(e) => handleStep7InputChange('Product4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Product4 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Product4}
                      </p>
                    )}
                  </div>

                  {/* Question 5 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    5. Do you measure yourself against your competitors’ offerings?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product5"
                          value="2"
                          checked={step7Data.Product5 === '2'}
                          onChange={(e) => handleStep7InputChange('Product5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product5"
                          value="1"
                          checked={step7Data.Product5 === '1'}
                          onChange={(e) => handleStep7InputChange('Product5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Product5"
                          value="0"
                          checked={step7Data.Product5 === '0'}
                          onChange={(e) => handleStep7InputChange('Product5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Product5 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Product5}
                      </p>
                    )}
                  </div>
                  
                  <div className="flex gap-4">
                    <button
                      type="button"
                      onClick={handleStep7Back}
                      className="flex-1 bg-gray-500 text-white py-3 px-6 rounded-md font-medium hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 flex items-center justify-center"
                    >
                      <ArrowRight className="mr-2 h-5 w-5 rotate-180" />
                      BACK
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="flex-1 bg-indigo-600 text-white py-3 px-6 rounded-md font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                    >
                      {isLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                          Processing...
                        </>
                      ) : (
                        <>
                          NEXT
                          <ArrowRight className="ml-2 h-5 w-5" />
                        </>
                      )}
                    </button>
                  </div>
                </form>
                </div>
          </div>
        </section>
      </div>
    );
  }

  //Question 8 - CLIENT MANAGEMENT
  if (currentStep === 8) {
    return (
      <div className="min-h-screen bg-gradient-to-br to-indigo-100">
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            CLIENT MANAGEMENT
            </h1>
            {answerStep('management')}
              <div className="bg-white p-8 w-full mx-auto mt-20">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 text-left">
                Do you know who your clients are?
                </h2>
                <p className="text-gray-600 mb-8 text-left">
                Client Management is about choosing and having the right relationships with clients that you work best with. When a business starts up any client is a good client - that is not the case as your business grows.
                </p>
                <h5 className="text-1xl font-bold text-gray-900 mb-2 text-left">
                What’s best practice in CLIENT MANAGEMENT?
                </h5>
                <ol className="list-decimal list-inside text-gray-600 mb-8 text-left">
                  <li>You know where your new markets are and how to generate revenue from them.</li>
                  <li>Your operational management systems track and understand the Buyer’s Journey.</li>
                  <li>You know the difference between good and bad clients – and your team does, too.</li>
                  <li>You reject clients who don’t fit your business.</li>
                  <li>Your business is clear on the key measures of success for a good client.</li>
                </ol>
                
                <form onSubmit={handleStep8Submit} className="space-y-8">
                  {/* Question 1 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    1. Does your business know how to open new markets?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management1"
                          value="2"
                          checked={step8Data.Management1 === '2'}
                          onChange={(e) => handleStep8InputChange('Management1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management1"
                          value="1"
                          checked={step8Data.Management1 === '1'}
                          onChange={(e) => handleStep8InputChange('Management1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management1"
                          value="0"
                          checked={step8Data.Management1 === '0'}
                          onChange={(e) => handleStep8InputChange('Management1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Management1 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Management1}
                      </p>
                    )}
                  </div>

                  {/* Question 2 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    2. Do you have a CRM system and have you recently reviewed how you store your client contact information?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management2"
                          value="2"
                          checked={step8Data.Management2 === '2'}
                          onChange={(e) => handleStep8InputChange('Management2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management2"
                          value="1"
                          checked={step8Data.Management2 === '1'}
                          onChange={(e) => handleStep8InputChange('Management2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management2"
                          value="0"
                          checked={step8Data.Management2 === '0'}
                          onChange={(e) => handleStep8InputChange('Management2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Management2 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Management2}
                      </p>
                    )}
                  </div>

                  {/* Question 3 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    3. Does your business have a defined client criteria – which are the good and the bad clients?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management3"
                          value="2"
                          checked={step8Data.Management3 === '2'}
                          onChange={(e) => handleStep8InputChange('Management3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management3"
                          value="1"
                          checked={step8Data.Management3 === '1'}
                          onChange={(e) => handleStep8InputChange('Management3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management3"
                          value="0"
                          checked={step8Data.Management3 === '0'}
                          onChange={(e) => handleStep8InputChange('Management3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Management3 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Management3}
                      </p>
                    )}
                  </div>

                  {/* Question 4 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    4. Do you choose which clients you work with?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management4"
                          value="2"
                          checked={step8Data.Management4 === '2'}
                          onChange={(e) => handleStep8InputChange('Management4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management4"
                          value="1"
                          checked={step8Data.Management4 === '1'}
                          onChange={(e) => handleStep8InputChange('Management4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management4"
                          value="0"
                          checked={step8Data.Management4 === '0'}
                          onChange={(e) => handleStep8InputChange('Management4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Management4 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Management4}
                      </p>
                    )}
                  </div>

                  {/* Question 5 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    5. Do you review your clients on a regular basis and exit the ones that are not right for your business?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management5"
                          value="2"
                          checked={step8Data.Management5 === '2'}
                          onChange={(e) => handleStep8InputChange('Management5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management5"
                          value="1"
                          checked={step8Data.Management5 === '1'}
                          onChange={(e) => handleStep8InputChange('Management5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Management5"
                          value="0"
                          checked={step8Data.Management5 === '0'}
                          onChange={(e) => handleStep8InputChange('Management5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Management5 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Management5}
                      </p>
                    )}
                  </div>
                  
                  <div className="flex gap-4">
                    <button
                      type="button"
                      onClick={handleStep8Back}
                      className="flex-1 bg-gray-500 text-white py-3 px-6 rounded-md font-medium hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 flex items-center justify-center"
                    >
                      <ArrowRight className="mr-2 h-5 w-5 rotate-180" />
                      BACK
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="flex-1 bg-indigo-600 text-white py-3 px-6 rounded-md font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                    >
                      {isLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                          Processing...
                        </>
                      ) : (
                        <>
                          NEXT
                          <ArrowRight className="ml-2 h-5 w-5" />
                        </>
                      )}
                    </button>
                  </div>
                </form>
                </div>
          </div>
        </section>
      </div>
    );
  }

  //Question 9 - CLIENT SERVICE
  if (currentStep === 9) {
    return (
      <div className="min-h-screen bg-gradient-to-br to-indigo-100">
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            CLIENT SERVICE
            </h1>
            {answerStep('services')}
              <div className="bg-white p-8 w-full mx-auto mt-20">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 text-left">
                Are your client service levels aligned?
                </h2>
                <p className="text-gray-600 mb-8 text-left">
                Client Service is about keeping the customers you have happy and engaged with your business. Businesses often forget the relationship they need to have with their customers after the sales process has been complete; they need attention.
                </p>
                <h5 className="text-1xl font-bold text-gray-900 mb-2 text-left">
                What’s best practice in CLIENT SERVICE?
                </h5>
                <ol className="list-decimal list-inside text-gray-600 mb-8 text-left">
                  <li>Someone in your business is responsible for prospects when they become clients.</li>
                  <li>You understand why you’re over- or under-servicing clients.</li>
                  <li>You regularly review your client engagement strategies.</li>
                  <li>You always ask: ‘What else can clients buy from us?’</li>
                  <li>You regularly gather client insights, outside of the sales process.</li>
                </ol>
                
                <form onSubmit={handleStep9Submit} className="space-y-8">
                  {/* Question 1 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    1. Do you have someone responsible for managing the client service program?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service1"
                          value="2"
                          checked={step9Data.Service1 === '2'}
                          onChange={(e) => handleStep9InputChange('Service1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service1"
                          value="1"
                          checked={step9Data.Service1 === '1'}
                          onChange={(e) => handleStep9InputChange('Service1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service1"
                          value="0"
                          checked={step9Data.Service1 === '0'}
                          onChange={(e) => handleStep9InputChange('Service1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Service1 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Service1}
                      </p>
                    )}
                  </div>

                  {/* Question 2 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    2. Are you consciously under and/or over servicing clients?
                    </h4>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service2"
                          value="2"
                          checked={step9Data.Service2 === '2'}
                          onChange={(e) => handleStep9InputChange('Service2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service2"
                          value="1"
                          checked={step9Data.Service2 === '1'}
                          onChange={(e) => handleStep9InputChange('Service2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service2"
                          value="0"
                          checked={step9Data.Service2 === '0'}
                          onChange={(e) => handleStep9InputChange('Service2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Service2 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Service2}
                      </p>
                    )}
                  </div>

                  {/* Question 3 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    3. Do you have a structured client service program?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service3"
                          value="2"
                          checked={step9Data.Service3 === '2'}
                          onChange={(e) => handleStep9InputChange('Service3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service3"
                          value="1"
                          checked={step9Data.Service3 === '1'}
                          onChange={(e) => handleStep9InputChange('Service3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service3"
                          value="0"
                          checked={step9Data.Service3 === '0'}
                          onChange={(e) => handleStep9InputChange('Service3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Service3 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Service3}
                      </p>
                    )}
                  </div>

                  {/* Question 4 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    4. Do you know how many products/services your clients buy from you?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service4"
                          value="2"
                          checked={step9Data.Service4 === '2'}
                          onChange={(e) => handleStep9InputChange('Service4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service4"
                          value="1"
                          checked={step9Data.Service4 === '1'}
                          onChange={(e) => handleStep9InputChange('Service4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service4"
                          value="0"
                          checked={step9Data.Service4 === '0'}
                          onChange={(e) => handleStep9InputChange('Service4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Service4 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Service4}
                      </p>
                    )}
                  </div>

                  {/* Question 5 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    5. Do you ask them how you could improve your service and understand what else they can buy from you?
                    </h4>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service5"
                          value="2"
                          checked={step9Data.Service5 === '2'}
                          onChange={(e) => handleStep9InputChange('Service5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Yes, it's working.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service5"
                          value="1"
                          checked={step9Data.Service5 === '1'}
                          onChange={(e) => handleStep9InputChange('Service5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">It's work in progress.</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Service5"
                          value="0"
                          checked={step9Data.Service5 === '0'}
                          onChange={(e) => handleStep9InputChange('Service5', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">No, it needs work.</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Service5 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Service5}
                      </p>
                    )}
                  </div>
                  
                  <div className="flex gap-4">
                    <button
                      type="button"
                      onClick={handleStep9Back}
                      className="flex-1 bg-gray-500 text-white py-3 px-6 rounded-md font-medium hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 flex items-center justify-center"
                    >
                      <ArrowRight className="mr-2 h-5 w-5 rotate-180" />
                      BACK
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="flex-1 bg-indigo-600 text-white py-3 px-6 rounded-md font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                    >
                      {isLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                          Processing...
                        </>
                      ) : (
                        <>
                          NEXT
                          <ArrowRight className="ml-2 h-5 w-5" />
                        </>
                      )}
                    </button>
                  </div>
                </form>
                </div>
          </div>
        </section>
      </div>
    );
  }
  //Question 10 - Organisation
  if (currentStep === 10) {
    return (
      <div className="min-h-screen bg-gradient-to-br to-indigo-100">
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Thanks, all done!
            </h1>
            {answerStep('all')}
              <div className="bg-white p-8 w-full mx-auto mt-20">
                <h2 className="text-2xl font-bold text-gray-900 mb-2 text-left">
                Just one more thing…
                </h2>
                <p className="text-gray-600 mb-1 text-left">
                Your answers are in the bag and we're busy putting them all together. Keep an eye on your inbox because your results will be arriving shortly.
                </p>
                <p className="text-gray-600 mb-8 text-left">
                Please complete the final step below to help us with benchmarking, we would really appreciate it. Your answers are anonymous.
                </p>
    
                <form onSubmit={handleStep10Submit} className="space-y-8">
                  {/* Question 1 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    Number of Employees
                    </h4>
                    <p className="text-gray-600 mb-4 text-left">
                    1. Select the category that best represents your current total headcount
                    </p>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation1"
                          value="Micro (1–9 employees)"
                          checked={step10Data.Organisation1 === 'Micro (1–9 employees)'}
                          onChange={(e) => handleStep10InputChange('Organisation1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Micro (1–9 employees)</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation1"
                          value="Small (10–49 employees)"
                          checked={step10Data.Organisation1 === 'Small (10–49 employees)'}
                          onChange={(e) => handleStep10InputChange('Organisation1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Small (10–49 employees</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation1"
                          value="Medium (50–249 employees)"
                          checked={step10Data.Organisation1 === 'Medium (50–249 employees)'}
                          onChange={(e) => handleStep10InputChange('Organisation1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Medium (50–249 employees)</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation1"
                          value="Large (250+ employees)"
                          checked={step10Data.Organisation1 === 'Large (250+ employees)'}
                          onChange={(e) => handleStep10InputChange('Organisation1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Large (250+ employees)</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation1"
                          value="Enterprise (500–999 employees)"
                          checked={step10Data.Organisation1 === '0'}
                          onChange={(e) => handleStep10InputChange('Organisation1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Enterprise (500–999 employees)</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation1"
                          value="Corporation (1,000+ employees)"
                          checked={step10Data.Organisation1 === '0'}
                          onChange={(e) => handleStep10InputChange('Organisation1', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Corporation (1,000+ employees)</p>
                        </div>
                      </label>

                      
                    </div>
                    
                    {errors.Organisation1 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Organisation1}
                      </p>
                    )}
                  </div>

                  {/* Question 2 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    Turnover (Annual Revenue)
                    </h4>
                    <p className="text-gray-600 mb-4 text-left">
                    2. Select your organisation’s approximate annual revenue:
                    </p>
                    <div className="space-y-3">
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation2"
                          value="Micro (<1M)"
                          checked={step10Data.Organisation2 === 'Micro (<1M)'}
                          onChange={(e) => handleStep10InputChange('Organisation2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Micro (less than 1M)</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation2"
                          value="Small (1M – 10M)"
                          checked={step10Data.Organisation2 === 'Small (1M – 10M)'}
                          onChange={(e) => handleStep10InputChange('Organisation2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Small (1M – 10M)</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation2"
                          value="Medium (10M – 50M)"
                          checked={step10Data.Organisation2 === 'Medium (10M – 50M)'}
                          onChange={(e) => handleStep10InputChange('Organisation2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Medium (10M – 50M)</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation2"
                          value="Large (50M – 250M)"
                          checked={step10Data.Organisation2 === 'Large (50M – 250M)'}
                          onChange={(e) => handleStep10InputChange('Organisation2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Large (50M – 250M)</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation2"
                          value="Enterprise (250M – 1B)"
                          checked={step10Data.Organisation2 === 'Enterprise (250M – 1B)'}
                          onChange={(e) => handleStep10InputChange('Organisation2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Enterprise (250M – 1B)</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation2"
                          value="Corporation (1B+)"
                          checked={step10Data.Organisation2 === '0'}
                          onChange={(e) => handleStep10InputChange('Organisation2', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Corporation (1B+)</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Organisation2 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Organisation2}
                      </p>
                    )}
                  </div>

                  {/* Question 3 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    Job Function
                    </h4>
                    <p className="text-gray-600 mb-4 text-left">
                    3. Select your primary job function:
                    </p>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation3"
                          value="Executive Leadership (e.g., CEO, Founder, MD, GM)"
                          checked={step10Data.Organisation3 === 'Executive Leadership (e.g., CEO, Founder, MD, GM)'}
                          onChange={(e) => handleStep10InputChange('Organisation3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Executive Leadership (e.g., CEO, Founder, MD, GM)</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation3"
                          value="Marketing & Communications (e.g., CMO, Marketing Manager, PR)"
                          checked={step10Data.Organisation3 === 'Marketing & Communications (e.g., CMO, Marketing Manager, PR)'}
                          onChange={(e) => handleStep10InputChange('Organisation3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Marketing & Communications (e.g., CMO, Marketing Manager, PR)</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation3"
                          value="Sales & Business Development (e.g., CSO, Account Manager)"
                          checked={step10Data.Organisation3 === 'Sales & Business Development (e.g., CSO, Account Manager)'}
                          onChange={(e) => handleStep10InputChange('Organisation3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Sales & Business Development (e.g., CSO, Account Manager)</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation3"
                          value="Operations & Administration (e.g., COO, Office Manager)"
                          checked={step10Data.Organisation3 === 'Operations & Administration (e.g., COO, Office Manager)'}
                          onChange={(e) => handleStep10InputChange('Organisation3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Operations & Administration (e.g., COO, Office Manager)</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation3"
                          value="Finance & Accounting (e.g., CFO, Accountant)"
                          checked={step10Data.Organisation3 === 'Finance & Accounting (e.g., CFO, Accountant)'}
                          onChange={(e) => handleStep10InputChange('Organisation3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Finance & Accounting (e.g., CFO, Accountant)</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation3"
                          value="Technology & IT (e.g., CTO, IT Manager, Developer)"
                          checked={step10Data.Organisation3 === 'Technology & IT (e.g., CTO, IT Manager, Developer)'}
                          onChange={(e) => handleStep10InputChange('Organisation3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Technology & IT (e.g., CTO, IT Manager, Developer)</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation3"
                          value="HR & People (e.g., CHRO, HR Manager)"
                          checked={step10Data.Organisation3 === 'HR & People (e.g., CHRO, HR Manager)'}
                          onChange={(e) => handleStep10InputChange('Organisation3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">HR & People (e.g., CHRO, HR Manager)</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation3"
                          value="Customer Service & Support (e.g., CXO, Customer Success)"
                          checked={step10Data.Organisation3 === 'Customer Service & Support (e.g., CXO, Customer Success)'}
                          onChange={(e) => handleStep10InputChange('Organisation3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Customer Service & Support (e.g., CXO, Customer Success)</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation3"
                          value="Procurement & Supply Chain (e.g., CPO, Logistics Manager)"
                          checked={step10Data.Organisation3 === 'Procurement & Supply Chain (e.g., CPO, Logistics Manager)'}
                          onChange={(e) => handleStep10InputChange('Organisation3', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Procurement & Supply Chain (e.g., CPO, Logistics Manager)</p>
                        </div>
                      </label>
                    </div>
                    
                    {errors.Organisation3 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.Organisation3}
                      </p>
                    )}
                  </div>

                  {/* Question 4 */}
                  <div>
                    <h4 className="text-1xl font-semibold text-gray-900 mb-4">
                    Sector
                    </h4>
                    <p className="text-gray-600 mb-4 text-left">
                    4. Select your business sector:
                    </p>
                    <div className="space-y-3">
                    <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Agriculture / Horticulture / Farming"
                          checked={step10Data.Organisation4 === 'Agriculture / Horticulture / Farming'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Agriculture / Horticulture / Farming</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Construction / Trades"
                          checked={step10Data.Organisation4 === 'Construction / Trades'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Construction / Trades</p>
                        </div>
                      </label>
                      
                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Creative / Media / Marketing"
                          checked={step10Data.Organisation4 === 'Creative / Media / Marketing'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Creative / Media / Marketing</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Education / Training"
                          checked={step10Data.Organisation4 === 'Education / Training'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Education / Training</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Energy / Utilities / Environmental"
                          checked={step10Data.Organisation4 === 'Energy / Utilities / Environmental'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Energy / Utilities / Environmental</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Finance / Insurance / Banking"
                          checked={step10Data.Organisation4 === 'Finance / Insurance / Banking'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Finance / Insurance / Banking</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Food & Beverage / Hospitality"
                          checked={step10Data.Organisation4 === 'Food & Beverage / Hospitality'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Food & Beverage / Hospitality</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Government / Public Sector"
                          checked={step10Data.Organisation4 === 'Government / Public Sector'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Government / Public Sector</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Health & Wellness / Fitness"
                          checked={step10Data.Organisation4 === 'Health & Wellness / Fitness'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Health & Wellness / Fitness</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Manufacturing / Industrial"
                          checked={step10Data.Organisation4 === 'Manufacturing / Industrial'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Manufacturing / Industrial</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Not-for-Profit / Social Enterprise"
                          checked={step10Data.Organisation4 === 'Not-for-Profit / Social Enterprise'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Not-for-Profit / Social Enterprise</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Professional Services (legal, accounting, consulting etc)"
                          checked={step10Data.Organisation4 === 'Professional Services (legal, accounting, consulting etc)'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Professional Services (legal, accounting, consulting etc)</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Real Estate / Property Services"
                          checked={step10Data.Organisation4 === 'Real Estate / Property Services'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Real Estate / Property Services</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Retail / E-commerce"
                          checked={step10Data.Organisation4 === 'Retail / E-commerce'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Retail / E-commerce</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Technology / Software / SaaS"
                          checked={step10Data.Organisation4 === 'Technology / Software / SaaS'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Technology / Software / SaaS</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="The Arts"
                          checked={step10Data.Organisation4 === 'The Arts'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">The Arts</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Tourism / Events / Experiences"
                          checked={step10Data.Organisation4 === 'Tourism / Events / Experiences'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Tourism / Events / Experiences</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Transport / Logistics / Delivery"
                          checked={step10Data.Organisation4 === 'Transport / Logistics / Delivery'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Transport / Logistics / Delivery</p>
                        </div>
                      </label>

                      <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                        <input
                          type="radio"
                          name="Organisation4"
                          value="Other – Please Specify"
                          checked={step10Data.Organisation4 === 'Other – Please Specify'}
                          onChange={(e) => handleStep10InputChange('Organisation4', e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <div className="ml-3">
                          <p className="text-gray-600 text-sm">Other – Please Specify</p>
                        </div>
                      </label>
                  
                    </div>
                    
                    {errors.Organisation4 && (
                      <p className="mt-2 text-sm text-red-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg> 
                        {errors.Organisation4}
                      </p>
                    )}
                  </div>
                  
                  <div className="flex gap-4">
                    
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="flex-1 bg-indigo-600 text-white py-3 px-6 rounded-md font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                    >
                      {isLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                          Processing...
                        </>
                      ) : (
                        <>
                          COMPLETE ASSESSMENT
                          <ArrowRight className="ml-2 h-5 w-5" />
                        </>
                      )}
                    </button>
                  </div>
                </form>
                </div>
          </div>
        </section>
      </div>
    );
  }

 

  if (currentStep === 11) {
    // Step 11: Final confirmation page - NO BACK BUTTON (survey completed)
    // Get session data from localStorage
    const sessionData = getSessionData();
    
    return (
      <div className="min-h-screen bg-gradient-to-br">
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
            
            <div className="bg-white p-8 w-full mx-auto">
              {/* Display dynamic subject/title */}
              {confirmationContent && confirmationContent.title && (
                <div 
                  className="font-bold text-gray-900 mb-6 text-center"
                  dangerouslySetInnerHTML={{ __html: confirmationContent.title }}
                />
              )}
                
              {/* Display main content */}
              {confirmationContent && confirmationContent.content && (
                <div 
                  className="text-gray-600 mb-4 text-center"
                  dangerouslySetInnerHTML={{ __html: confirmationContent.content }}
                />
              )}
              
              {/* Show loading state while fetching */}
              {!confirmationContent && (
                <div className="text-center py-8">
                  <p className="text-gray-500">Loading confirmation message...</p>
                </div>
              )}
              
              {/* Show message if no content found */}
              {confirmationContent && !confirmationContent.title && !confirmationContent.content && (
                <div className="text-center">
                  <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
                    Thank you for completing your MSQ Index!
                  </h1>
                  <p className="text-gray-600 mb-2">
                    Keep an eye on your inbox because your results will be popping in shortly.
                  </p>
                </div>
              )}
              
              <div className="mt-8"> 
                <a href={`/${sessionData?.site_slug || ''}`} className="flex-1 bg-indigo-600 text-white py-3 px-6 rounded-md font-medium  focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                >Start Again</a>
              </div> 
            </div>
          </div>
        </section>
      </div>
    );
  }

  return null;
};

export default MSQIndex;
